import type {
	CheckoutOrderStatusResponse,
	CheckoutsOrdersDetailResponse,
	CheckoutsOrdersNewResponse,
	CheckoutsOrdersPaymentMethodResponse,
	CheckoutsOrdersRequest,
	ConfirmCheckoutOrderResponse,
	SurveyFormRequest,
	UserCheckoutOptionsResponse,
} from '@/types/checkout';
import type { ErrorResponse } from '@/types/common';

export const postCheckoutsOrdersAPI = (payload: Partial<CheckoutsOrdersRequest>) => {
	return useRequest<CheckoutsOrdersNewResponse, ErrorResponse>(
		CHECK_OUTS_ORDERS_ENDPOINT,
		REQUEST_METHOD.POST,
		{
			...payload,
		},
		{},
		{},
		true,
	);
};

export const getUserCheckoutOptionsAPI = (userId: number, eventId: number) => {
	const endPoint = `${USERS_ENDPOINT}/${userId}/account/checkout-options`;
	return useRequest<UserCheckoutOptionsResponse, ErrorResponse>(
		endPoint,
		REQUEST_METHOD.GET,
		{},
		{
			eventId,
		},
		{},
		true,
	);
};

export const patchCheckoutOrderBuyerInfoByOrderIdAPI = (
	orderId: string,
	payload: Partial<CheckoutsOrdersRequest>,
) => {
	return useRequest<{}, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/buyer-info`,
		REQUEST_METHOD.PATCH,
		payload,
		{},
		{},
		true,
	);
};

export const postConfirmCheckoutsOrdersAPI = ({
	orderId,
	paymentMethodId,
	paymentMethodType,
}: {
	orderId: string;
	paymentMethodId?: string;
	paymentMethodType?: string;
}) => {
	return useRequest<ConfirmCheckoutOrderResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/confirm`,
		REQUEST_METHOD.POST,
		{
			...(paymentMethodId ? { paymentMethodId } : {}),
			...(paymentMethodType ? { paymentMethodType } : {}),
		},
		{},
		{},
		true,
	);
};

export const getCheckoutOrdersStatusAPI = (orderId: string) => {
	return useRequest<CheckoutOrderStatusResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/status`,
		REQUEST_METHOD.GET,
		{},
		{},
		{},
		true,
	);
};

export const patchSurveyFormByOrderIdAPI = (orderId: string, payload: SurveyFormRequest) => {
	return useRequest<{}, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/survey`,
		REQUEST_METHOD.PATCH,
		{
			formId: payload.formId,
			userResponse: payload.data,
		},
		{},
		{},
		true,
	);
};

export const getCheckoutOrderPaymentMethodsByOrderIdAPI = (orderId: string) => {
	return useRequest<CheckoutsOrdersPaymentMethodResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}/payment-methods`,
		REQUEST_METHOD.GET,
		{},
		{},
		{},
		true,
	);
};

export const getCheckoutOrderDetailByOrderIdAPI = (orderId: string) => {
	return useRequest<CheckoutsOrdersDetailResponse, ErrorResponse>(
		`${CHECK_OUTS_ORDERS_ENDPOINT}/${orderId}`,
		REQUEST_METHOD.GET,
		{},
		{},
		{},
		true,
	);
};